<div mode="ios" class="card" *ngIf="!loading" style="border-radius: 18px;">
  <div class="card-content" *ngIf="special; else nothing">
   
<!-- 
    <div id="topOfCard">
      <div style="border-radius: 18px 18px 0px 0px;">
        <div  id="title-container">
         <h2>{{special.descriptive_tag}}</h2>
       </div>
       <ion-item >
        <ion-thumbnail style="    height: 7em;
        width: 7em;
        --border-radius: 9px;
        margin: 0.5em;">
          <img  
          id="background-image"
          [defaultImage]="assetLinksService.cardLoading" 
          [lazyLoad]="special.picture" 
          [errorImage]="assetLinksService.noImage"
          onerror="this.src='assets/errorimg_ink.png'">
        </ion-thumbnail>
         <ion-label color="secondary">
           <strong>{{special.restaurant_name}} | {{special.name}}</strong>
           <p>{{voucher.expirationDate_unix_utc | daysLeft}}</p>
         </ion-label>
       </ion-item> 
     
       </div>
    </div> -->

    <div id="topOfCard">
      <div  id="title-container">
        <h2>{{special?.descriptive_tag}}</h2>
      </div>
      <ion-item lines="none" id="dealNameItem">
        <ion-label color="light">
          <strong>{{special?.restaurant_name}} | {{special?.name}}</strong>
        </ion-label>
      </ion-item>
      <div id="img-container" class="fade-in">
        <img  
        id="background-image"
        [defaultImage]="assetLinksService.cardLoading" 
        [lazyLoad]="special?.picture" 
        [errorImage]="assetLinksService.noImage"
        onerror="this.src='assets/errorimg_ink.png'">
        <!-- <ion-spinner  name="dots"></ion-spinner> -->
      </div>
      <ion-item lines="none" id="expiryItem" >
        <ion-label color="dark">
          <strong>{{voucher.expirationDate_unix_utc | daysLeft}}</strong>
        </ion-label>
      </ion-item>
    </div>


      <div id="redeem-button-container">
        <div style="    
        width: 100%;
        height: 2px;
        display: flex;
        margin: 0;
        padding: 0;
        text-align: center;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;">
          <div  style="    
          width: 80%;
          height: 100%;
          border: 1px dashed var(--ion-color-medium);
          margin: 0;
          padding: 0;
          "></div>
        </div>

        <!-- <ion-item lines="none"  style="text-align: center; border-radius: 18px;">
          <ion-label color="secondary">
            <strong>Redeem voucher</strong>
            <p>Choose a redemption method</p>
          </ion-label>
        </ion-item> -->
        <!-- <ion-grid fixed>
          <ion-row>
            <ion-col >
              <ion-button [disabled]="dateTimeService.isExpired(voucher.expirationDate_unix_utc) || isButtonLoading" expand="block" (click)="redeemVoucher('QR')" >
                {{isButtonLoading? '' : 'SCAN' }} 
                <ion-icon *ngIf="!isButtonLoading"  slot="end" name="scan"></ion-icon>
                <ion-spinner *ngIf="isButtonLoading" name="dots"></ion-spinner>
              </ion-button>
            </ion-col>
            <ion-col *ngIf="scanService.isNfcSupported" >
              <ion-button [disabled]="dateTimeService.isExpired(voucher.expirationDate_unix_utc) || isButtonLoading" expand="block" (click)="redeemVoucher('NFC')" >
                {{isButtonLoading? '' : 'TAP' }} 
                <ion-icon *ngIf="!isButtonLoading"  slot="end" name="radio"></ion-icon>
                <ion-spinner *ngIf="isButtonLoading" name="dots"></ion-spinner>
              </ion-button>
            </ion-col>
            <ion-col>
         
            </ion-col>
          </ion-row>
        </ion-grid> -->
        <ion-button style="padding:1em;" [disabled]="dateTimeService.isExpired(voucher.expirationDate_unix_utc) || isButtonLoading" expand="block"  (click)="showRedemptionOptions()" >
          {{isButtonLoading? '' : 'Redeem Voucher' }} 
          <ion-icon *ngIf="!isButtonLoading" slot="end"  name="gift"></ion-icon>
          <ion-spinner *ngIf="isButtonLoading" name="dots"></ion-spinner>
        </ion-button>
      </div>
  </div>
  <ng-template #nothing>
    <div class="card-content">
      <div  id="title-container">
        <h2>Error</h2>
      </div>
      <div id="img-container" class="fade-in">
        <img  
        id="background-image"
        [defaultImage]="assetLinksService.cardLoading" 
        [lazyLoad]="assetLinksService.noImage" 
        [errorImage]="assetLinksService.noImage"
        onerror="this.src='assets/errorimg_ink.png'">
        <!-- <ion-spinner  name="dots"></ion-spinner> -->
      </div>
        <ion-item  style="text-align: center;">
          <ion-label color="secondary">
            <strong>Error fetching loyalty programme</strong>
            <p>
              Please check your internet connection.
              Try closing the app completely (not just minimize) 
              and re-open the app
            </p>
          </ion-label>
        </ion-item>
        <div id="redeem-button-container">
   
        </div>
    </div>
  </ng-template>
</div>

<div
style="height: 50vh; margin: 0.5em;"
mode="ios"
*ngIf="loading">
<ion-skeleton-text animated style="width: 100%;height: 100%;"></ion-skeleton-text>
</div>